export function getAge(dateString: string): number {
  // For demonstration, we fix "today" as 2025-03-20.
  // In a real-world app, use `new Date()` to get the current date.
  const today = new Date("2025-03-20");
  const birthDate = new Date(dateString);
  let age = today.getFullYear() - birthDate.getFullYear();

  // Check if the birthday hasn't occurred yet this year.
  const hasNotHadBirthdayThisYear =
    today.getMonth() < birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() &&
      today.getDate() < birthDate.getDate());

  if (hasNotHadBirthdayThisYear) {
    age--;
  }

  return age;
}
